export { Thumbnail } from './Thumbnail'
export type { ThumbnailProps } from './Thumbnail'
export { SimpleThumbnail } from './SimpleThumbnail'
